<slick-dialog #dialogRef [showHeader]="false" width="460" cssClass="duplicate-customers-dialog" key="conflictingCustomersDialog" [resizable]="false" [draggable]="false" [minimizable]="false" [noPadding]="true" [disableScrollbar]="true" (onClose)="cancel()">
	<div class="duplicate-dialog" *ngIf="newCustomer">
		<div class="duplicate-dialog__header-section">
			<div class="duplicate-dialog__topbar">
				<div class="duplicate-dialog__header">
					<i class="fas fa-exclamation-triangle text-danger duplicate-dialog__icon" aria-hidden="true"></i>
					<h5 class="duplicate-dialog__title mb-0">Potential duplicate customer found!</h5>
				</div>
				<button type="button" class="duplicate-dialog__close" aria-label="Close" (click)="cancel()">
					<i class="far fa-times" aria-hidden="true"></i>
				</button>
			</div>

			<p class="duplicate-dialog__subtitle mb-3">{{ headlineMessage }}</p>

			<div class="duplicate-dialog__entry mb-3">
				<div class="duplicate-dialog__entry-label">Your Entry:</div>
				<div class="duplicate-dialog__entry-values">
					<div *ngIf="getDisplayName(newCustomer)" class="duplicate-dialog__entry-value fw-bold">{{ getDisplayName(newCustomer) }}</div>
					<div *ngIf="showPersonName(newCustomer)" class="duplicate-dialog__entry-value">{{ getPersonName(newCustomer) }}</div>
					<div *ngIf="getFullAddress(newCustomer)" class="duplicate-dialog__entry-value">{{ getFullAddress(newCustomer) }}</div>
				</div>
			</div>
		</div>

		<div class="duplicate-dialog__matches">
			<div *ngFor="let duplicateCheck of duplicateChecks" class="duplicate-card">
				<div class="duplicate-card__header">
					<span class="duplicate-card__label">Existing Customer</span>
					<button type="button" class="btn btn-sm btn-outline-primary" (click)="useExistingCustomer(duplicateCheck.customer.customerId)">Use This Customer</button>
				</div>

				<div class="duplicate-card__name fw-bold">{{ getDisplayName(duplicateCheck.customer) }}</div>
				<div *ngIf="showPersonName(duplicateCheck.customer)" class="duplicate-card__person">{{ getPersonName(duplicateCheck.customer) }}</div>
				<div *ngIf="getFullAddress(duplicateCheck.customer)" class="duplicate-card__address">{{ getFullAddress(duplicateCheck.customer) }}</div>

				<span class="badge duplicate-card__badge">Matches: {{ duplicateCheck.matchReasons.join(', ') }}</span>
			</div>
		</div>
	</div>

	<slick-dialog-footer *ngIf="newCustomer">
		<div class="duplicate-dialog__footer">
			<button type="button" class="btn btn-outline-success me-2" (click)="keepEnteringNewCustomer()"><i class="far fa-check"></i> Continue Creating New Customer</button>
			<button type="button" class="btn btn-outline-danger" (click)="cancel()"><i class="far fa-ban"></i> Close</button>
		</div>
	</slick-dialog-footer>
</slick-dialog>
